import TableColumn from "@component/common/TableColumn";
import TableHeader from "@component/common/TableHeader";
import { APPROVE_INFO } from "@constant/APPROVE_INFO";

export default function ApproveColumn() {
  return (
    <TableHeader>
      {APPROVE_INFO.map(({ COLUMN, WIDTH }, index) => {
        return (
          <TableColumn key={index} width={WIDTH}>
            {COLUMN}
          </TableColumn>
        );
      })}
    </TableHeader>
  );
}
